import React, { useState } from 'react';
import { SelectPatientByIdForm } from 'shared/patientSearch/SelectPatientByIdForm';
import { RepairForForm } from './RepairForForm';
import { RegisterRepairRequestForm } from './RegisterRepairRequestForm';

interface IProps {
	confirm: (id: string) => void;
	cancel: VoidFunction;
}

type State = 'for' | 'patient' | 'model';

export const RegisterRepair = ({ cancel, confirm }: IProps) => {
	const [state, setState] = useState<State>('for');
	const [patientId, setPatientId] = useState<string>();

	const confirmFor = (isForPatient: boolean) => {
		setState(isForPatient ? 'patient' : 'model');
		setPatientId(undefined);
	};

	const confirmPatient = (patientId: string) => {
		setPatientId(patientId);
		setState('model');
	};

	if (state === 'for') {
		return (
			<RepairForForm
				open
				confirm={confirmFor}
				cancel={cancel}
			/>
		);
	} else if (state === 'patient') {
		return (
			<SelectPatientByIdForm
				open
				confirm={confirmPatient}
				cancel={cancel}
			/>
		);
	} else {
		return (
			<RegisterRepairRequestForm
				open
				confirm={confirm}
				cancel={cancel}
				patientId={patientId}
			/>
		);
	}
};
